import { render } from "./GorusmebilgilerDetayView.vue?vue&type=template&id=099d5172"
import script from "./GorusmebilgilerDetayView.vue?vue&type=script&lang=js"
export * from "./GorusmebilgilerDetayView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__